
// Import JS Modules
import { builderDispatch, PrismUI } from '../../_utils/ui';
import { usePrismItemStore } from 'stores/usePrismItemStore';

var TemplateCache = {
  store: {},
  fetches: {},
  reset() {
    TemplateCache.store = {};
  },
  textSlotMetaToSlotData(meta) {
    return ({
      align: meta.align,
      fontColour: meta.fill,
      fontName: meta.font,
      fontSize: meta.size,
      fontWeight: meta.weight,
      renderer: 'default',
      valign: meta.valign,
      stroke: meta.stroke,
      zoom: 1,
      x: meta['pixel-coords'][0],
      y: meta['pixel-coords'][1],
      w: meta['pixel-coords'][2],
      h: meta['pixel-coords'][3],
    });
  },
  get(id, onSuccessCallback, onFailureCallback) {
    if (id === '@blank') {
      return;
    }

    if (this.store[id]) {
      if (typeof onSuccessCallback === 'function') {
        window.requestAnimationFrame(() => {
          onSuccessCallback(this.store[id]);
        });
      }

      return;
    }

    if (!this.fetches[id]) {
      fetch(`/m/t/${usePrismItemStore.getState().prismItem.id}`, {
        credentials: 'same-origin',
      }).then((response) => response.json())
      .then((groups) => {
        const group = groups.find((group) => {
          return group.templates.find((template) => {
            return template.id === id;
          });
        });
        if (!group) {
          // Template not found in this product's groups — stale id from a previous
          // product (e.g. fired before the option reload completed). Fire failure
          // callbacks so any waiting Promises resolve rather than hang, then drop.
          (this.fetches[id] || []).forEach(({ failure }) => {
            if (typeof failure === 'function') failure();
          });
          delete this.fetches[id];
          return;
        }
        const template = group.templates.find((template) => {
          return template.id === id;
        })

        this.fetchThemeData(id, template.theme)
      }).catch((e) => console.error(e));
    }

    this.fetches[id] = (this.fetches[id] || []);
    if (onSuccessCallback || onFailureCallback) {
      this.fetches[id].push({ success: onSuccessCallback, failure: onFailureCallback });
    }
  },
  slotSignature(template) {
    if (!template || !template.pso || !template.tso) {
      console.log('Invalid template: %o', template);
      return null;
    }
    return `${template.pso.sort().filter((el) => el.indexOf(':') === -1).join(';')};${template.tso.sort().join(';')}`;
  },
  templatesMatch(a, b) {

    return a && (this.slotSignature(a) === this.slotSignature(b));
  },
  fetchThemeData(id, theme) {
    fetch(`/m/td/${usePrismItemStore.getState().prismItem.id}/${theme}/${id}`, {
      credentials: 'same-origin',
    }).then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
      .then((response) => response.json())
      .then((data) => {
        this.store[id] = data;

        this.fetches[id].forEach(({ success }) => {
          if (typeof success === 'function') {
            success(data);
          }
        });

        delete this.fetches[id];
      })
      .catch((e) => console.error(e));
    }
};

builderDispatch.register((payload) => {
  if (payload.type === PrismUI.THEME_CHANGED) {
    TemplateCache.reset();
  }
});

export default TemplateCache;
